module.exports = __webpack_public_path__ + "img/Geburtstagsparty.228e18e0.jpg";